module.exports = __webpack_public_path__ + "static/img/5.d0708f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/zh/5.png
// module id = +8IR
// module chunks = 0